<template>
    <div class="flex max-h-[82vh] flex-col overflow-hidden bg-gray-50">
        <!-- 頂部 -->
        <div
            class="flex-none border-b border-gray-100 bg-white px-4 py-4"
        >
            <div class="mb-3 flex items-center justify-between">
                <div>
                    <h2 class="text-base font-bold text-gray-900">購物車</h2>
                    <p class="mt-1 text-xs text-gray-400">{{ count }} 件商品</p>
                </div>
                <button
                    type="button"
                    class="flex h-9 w-9 items-center justify-center rounded-full bg-gray-100 text-gray-500"
                    aria-label="關閉購物車"
                    @click="close"
                >
                    <XIcon class="h-5 w-5" />
                </button>
            </div>

            <button
                v-if="hasItems"
                type="button"
                class="text-xs font-bold text-red-500"
                @click="clear"
            >
                清空購物車
            </button>
        </div>

        <!-- 內容 -->
        <div class="min-h-0 flex-grow overflow-y-scroll bg-white">
            <CartListItem
                :amount="amount"
                :origin_amount="origin_amount"
                :items="items"
                :count="count"
                :hasItems="hasItems"
                :offer="offer"
            />
            <div class="h-6" />
        </div>

        <!-- 底部 -->
        <div
            class="flex-none border-t border-gray-100 bg-white px-4 pt-3"
            style="padding-bottom: max(18px, env(safe-area-inset-bottom, 18px))"
        >
            <div class="flex items-center justify-between gap-4">
                <div class="min-w-0">
                    <p class="text-xs font-medium text-gray-400">合計</p>
                    <p class="mt-0.5 text-xl font-black text-primary">
                        {{ currency }}{{ amount | number_format }}
                    </p>
                </div>
                <button
                    type="button"
                    class="h-12 flex-none rounded-lg px-8 text-base font-bold text-white"
                    :class="{
                        'bg-primary': hasItems,
                        'bg-gray-200 text-gray-500 cursor-not-allowed': !hasItems,
                    }"
                    @click="checkout"
                >
                    去結算
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import CartListItem from "@/components/cart/CartListItem";
import { XIcon } from "@vue-hero-icons/outline";
import { mapGetters, mapActions } from "vuex";

export default {
    components: { CartListItem, XIcon },

    methods: {
        ...mapActions({
            clear: "cart/clear",
        }),

        close() {
            this.$parent.close();
        },

        checkout() {
            if (!this.hasItems) return;
            this.close();
            this.$router.push(this.localePath({ name: "order-checkout" }));
        },
    },

    computed: {
        ...mapGetters({
            amount: "cart/amount",
            origin_amount: "cart/origin_amount",
            offer: "cart/offer",
            count: "cart/count",
            hasItems: "cart/hasItems",
            items: "cart/items",
        }),
        atCheckout() {
            return this.$route.name == "order-checkout";
        },
        atConfirm() {
            return this.$route.name == "order-confirm";
        },
    },
};
</script>
